<template>
  <div class="navbar">
    <nav class=" blue-grey darken-1">
      <div class="container">
        <router-link :to="{ name: 'Home' }" class="brand-logo center hide-on-small-only">フィルフィル-β</router-link>
        <ul class="right">
          <li v-if="!user"><router-link :to="{ name: 'Signup' }">登録</router-link></li>
          <li v-if="!user"><router-link :to="{ name: 'Login' }">ログイン</router-link></li>
          <li v-if="user" class="hide-on-small-only"><router-link :to="{ name: 'Home' }">ホーム</router-link></li>
          <li v-if="user"><a @click="logout">Logout</a></li>
        </ul>
      </div>

      <div v-if="user" class="nav-content blue-grey darken-1  hide-on-med-and-up">
        <ul class="tabs tabs-transparent">
          <li class="tab"><i class="large material-icons"><router-link :to="{ name: 'Home' }">home</router-link></i></li>
          <li class="tab"><i class="large material-icons"><router-link :to="{ name: 'SearchContent' }">search</router-link></i></li>
          <li class="tab"><i class="large material-icons"><router-link :to="{ name: 'AddContent' }">add_box</router-link></i></li>
          <li class="tab"><i class="large material-icons"><router-link :to="{ name: 'ViewProfile', params: { id: name }} ">account_circle</router-link></i></li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import firebase from 'firebase'
import db from '@/firebase/init'
export default{
  name: 'Navbar',
  data(){
    return{
      user: null,
      name: null
    }
  },
  created(){
    // let user = firebase.auth().currentUser
    firebase.auth().onAuthStateChanged((user) => {
      if(user){
        this.user = user

        db.collection('users').where('user_id', '==', firebase.auth().currentUser.uid).get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            console.log(doc)
            this.name = doc.id
          })
        })



      } else {
        this.user = null
      }
    });

  },
  methods: {
    logout(){
      firebase.auth().signOut().then(()=>{
        this.$router.push({ name: 'Login' })
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/Navbar.vue